import { ChildGender } from "~/types";
import { formatAgeGenderDescription } from "./formatAgeGenderDescription";
import { formatAgeGenderEmoji } from "./formatAgeGenderEmoji";

/**
 * Formats age and gender into a Romanian description
 * Examples: "băiețel nou-născut", "fetiță de 2 ani", "băiețel de 5 ani"
 */
export const formatAgeGenderNameDescription = (
  age: number | null | undefined,
  gender: ChildGender | undefined,
  childName: string | undefined,
  includeEmoji: boolean = false,
): string => {
  const ageGender = formatAgeGenderDescription(age, gender);
  const emoji =
    includeEmoji && ageGender ? formatAgeGenderEmoji(age, gender) + " " : "";
  if (childName && ageGender) {
    return `${emoji}${childName}, ${ageGender}`;
  } else if (childName) {
    return `${emoji}${childName}`;
  } else if (ageGender) {
    return `${emoji}${ageGender}`;
  } else {
    return "";
  }
};
